import { render, staticRenderFns } from "./OnboardNewContract.vue?vue&type=template&id=c388aa1e&"
import script from "./OnboardNewContract.vue?vue&type=script&lang=js&"
export * from "./OnboardNewContract.vue?vue&type=script&lang=js&"
import style0 from "./OnboardNewContract.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports